export default __webpack_public_path__ + "static/184-d51535a3edc808400b97199688135f2d.jpg";